import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#2a2622] text-[#e6ddcc]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="eyebrow label-caps mb-6 text-[#c88a83]" style={{ color: '#c88a83' }}>
              <span className="before:hidden">Based in Tauranga</span>
            </div>
            <div className="font-serif text-[42px] leading-none">
              Trusted <span className="text-[#c88a83]">Hands</span>
              <span className="text-[#c88a83] text-[22px] align-super ml-1">NZ</span>
            </div>
            <p className="mt-6 text-[14.5px] leading-[1.75] text-[#c1b7a3] max-w-[360px]">
              Management &amp; operations consulting for New Zealand businesses, based in Tauranga. A steady, trusted pair of hands.
            </p>
          </div>

          <div>
            <div className="label-caps text-[#c88a83] mb-5">Contact</div>
            <ul className="space-y-3 text-[14.5px] text-[#e6ddcc]">
              <li>
                <a href="mailto:trustedhandsnz@gmail.com" className="hover:text-[#c88a83] transition-colors">
                  trustedhandsnz@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+642040274459" className="hover:text-[#c88a83] transition-colors">
                  020 4027 4459
                </a>
              </li>
              <li className="text-[#c1b7a3]">Tauranga, Bay of Plenty</li>
            </ul>
          </div>

          <div>
            <div className="label-caps text-[#c88a83] mb-5">Navigate</div>
            <ul className="space-y-3 text-[14.5px]">
              <li><a href="#services" className="hover:text-[#c88a83] transition-colors">Services</a></li>
              <li><a href="#about" className="hover:text-[#c88a83] transition-colors">About</a></li>
              <li><a href="#how" className="hover:text-[#c88a83] transition-colors">How it works</a></li>
              <li><a href="#contact" className="hover:text-[#c88a83] transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#3d3833] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[13px] text-[#a89f8f]">
            © 2026 Trusted Hands NZ. All rights reserved.
          </p>
          <p className="label-caps text-[#a89f8f]">5–15 hours per week · Contract basis</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
